var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L54 0 54 54 0 54z",
    transform: "translate(-287 -867) translate(249 829) translate(38 38)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2CABE0",
    fillRule: "nonzero",
    d: "M27 5c-8.846 0-16 7.043-16 15.75C11 32.563 27 50 27 50s16-17.438 16-29.25C43 12.043 35.846 5 27 5zm0 21.375c-3.154 0-5.714-2.52-5.714-5.625s2.56-5.625 5.714-5.625c3.154 0 5.714 2.52 5.714 5.625s-2.56 5.625-5.714 5.625z",
    transform: "translate(-287 -867) translate(249 829) translate(38 38)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinQuestion);
export default __webpack_public_path__ + "static/media/pin-question.f1edd62c97ccb26daf6112b0151ec704.svg";
export { ForwardRef as ReactComponent };